<div class="add-widget-catalog-dialog">
  <h1 mat-dialog-title>
    <mat-icon class="v-middle">store</mat-icon>
    {{ ('page.widgetContent.addCatalogDialog.title' | translate) + ' (' + widgetData().length + ')' }}
  </h1>
  <div mat-dialog-content>
    <mat-form-field class="search-container py-2" appearance="outline" subscriptSizing="dynamic">
      <mat-label>{{ 'field.search' | translate }}</mat-label>
      <input matInput [formControl]="searchFilterFormControl" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <mat-chip-listbox selectable multiple [aria-orientation]="'horizontal'" [formControl]="chipFilterFormControl">
      @for (filter of filters; track filter) {
        <mat-chip-option [value]="filter.value"
          >{{ workspaceModuleService.moduleNames[filter.value] + ' (' + filter.numberOfWidgets + ')' }}
        </mat-chip-option>
      }
    </mat-chip-listbox>
    <div class="row mt-3">
      @for (catalogItem of catalogItems(); track catalogItem) {
        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-1">
          <mat-card appearance="outlined">
            <mat-card-header>
              <div mat-card-avatar class="pe-2">
                <img
                  height="40px"
                  src="../../../assets/images/modules/{{ catalogItem.relatedModules[0] }}.png"
                  alt="{{ catalogItem.relatedModules[0] }}-icon"
                />
              </div>
              <mat-card-title class="f-16">{{ catalogItem.widgetName }}</mat-card-title>
              <mat-card-subtitle class="f-12 text-grey">
                <span *ngFor="let module of catalogItem.relatedModules; let isLast = last"
                  >{{ workspaceModuleService.moduleNames[module] }}{{ isLast ? '' : ', ' }}</span
                >
              </mat-card-subtitle>
            </mat-card-header>
            <app-widget-catalog-item mat-card-image [widgetType]="catalogItem.type"></app-widget-catalog-item>
            <mat-card-content>
              <p class="widget-description">
                {{ catalogItem.description }}
              </p>
            </mat-card-content>
            <mat-card-actions>
              @let isModuleAvailable = !catalogItem.firstModuleWithoutPermission;
              <button
                *ngIf="isModuleAvailable"
                mat-flat-button
                type="button"
                class="add-widget-button"
                (click)="openAddModal(catalogItem.type)"
              >
                <mat-icon class="material-icons-outlined"> add</mat-icon>
                {{ 'button.add' | translate }}
              </button>

              <a [href]="environment.bookDemoUrl" target="_blank">
                <button *ngIf="!isModuleAvailable" mat-stroked-button type="button" class="add-widget-button">
                  <mat-icon class="material-icons-outlined">local_mall</mat-icon>
                  {{ 'button.bookADemo' | translate }}
                </button>
              </a>
            </mat-card-actions>
          </mat-card>
        </div>
      }
    </div>
  </div>

  <mat-dialog-actions align="end">
    <button matButton="tonal" type="button" mat-dialog-close>
      {{ 'button.close' | translate }}
    </button>
  </mat-dialog-actions>
</div>
